"use strict";
exports.__esModule = true;
exports.ReactiveMap = void 0;
var ReactiveMap = /** @class */ (function () {
    function ReactiveMap(initialState) {
        this.state = initialState || {};
        this.childMaps = new Map();
    }
    ReactiveMap.prototype.getOrCreateChildMap = function (key, initialState) {
        var existing = this.childMaps.get(key);
        if (existing) {
            return existing;
        }
        var created = new ReactiveMap(initialState);
        this.childMaps.set(key, created);
        return created;
    };
    ReactiveMap.prototype.get = function (path, initialState) {
        if (path === void 0) { path = []; }
        if (initialState === void 0) { initialState = {}; }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var target = this;
        for (var i = 0; i < path.length; i++) {
            var possibleInitialState = i === path.length - 1 && initialState;
            target = target.getOrCreateChildMap(path[i], possibleInitialState);
        }
        return target.state;
    };
    return ReactiveMap;
}());
exports.ReactiveMap = ReactiveMap;
